import { useState } from "react";
import { useTranslation } from "react-i18next";
import { API } from "../components/sign-out-modal/api";
import { SignOutFailureType } from "../constant/sign-out";
import { useGlobalStore } from "@/store/GlobalStore";
export const useSignOut = () => {
  const { t } = useTranslation("profile");
  const { isDomestic } = useGlobalStore();
  const [openSignOutModal, setOpenSignOutModal] = useState(false);
  const [openTipModal, setOpenTipModal] = useState(false);
  const [tipContent, setTipContent] = useState("");
  const onSignOutCancel = () => {
    setOpenSignOutModal(false);
  };
  const onSignOutConfirm = () => {
    setOpenSignOutModal(false);
  };
  const showConfirm = (code?: SignOutFailureType) => {
    const notSignOut =
      code &&
      [
        SignOutFailureType.HAS_BALANCE,
        // SignOutFailureType.HAS_BALANCE_NEGATIVE,
        SignOutFailureType.HAS_CREDIT,
        SignOutFailureType.HAS_CREDIT_SUB,
        SignOutFailureType.HAS_BALANCE_SUB,
        // SignOutFailureType.HAS_BALANCE_NEGATIVE_SUB,
        SignOutFailureType.HAS_JOB_UNSTOP,
        SignOutFailureType.HAS_JOB_UNSTOP_SUB,
      ].includes(code);
    let content = "";
    if (
      code === SignOutFailureType.HAS_BALANCE_NEGATIVE ||
      code === SignOutFailureType.HAS_BALANCE_NEGATIVE_SUB
    ) {
      content = t(`user_sign_out_code_${code}`, { 0: isDomestic ? "¥" : "$" });
    } else {
      content = notSignOut ? t(`user_sign_out_code_${code}`) : "";
    }
    setTipContent(content);
    !!content && setOpenTipModal(true);
    return !content;
  };
  const onSignOutOpen = async () => {
    const { code } = await API.checkDelete();

    showConfirm(code as number) && setOpenSignOutModal(true);
  };
  return {
    openSignOutModal,
    setOpenSignOutModal,
    onSignOutCancel,
    onSignOutConfirm,
    onSignOutOpen,
    openTipModal,
    setOpenTipModal,
    tipContent,
  };
};
